module.exports = __webpack_public_path__ + "img/404icon.2c0747b9.svg";